<template>
  <b-container id="clientSurvey" fluid class="h-100">
    <b-row class="justify-content-md-center" align-v="center">
      <b-col md="8">
        <b-col md="12">
          <b-col md="12" id="clientSurveyContainer">
            <b-row>
              <b-navbar toggleable="md" id="header" class="text-center blue-banner">
                <router-link id="logo" :to="{ name: 'Home' }" class="navbar-brand">
                  <img src="/img/logos/logo_white.png" id="logo-image"/>
                </router-link>
                <organization-logo v-if="organizationLogo" :organizationInfo="organizationInfo"></organization-logo>
              </b-navbar>
            </b-row>
            <b-row>
              <b-container v-if="!showSurvey && !showThanksSection">
                <b-row class="mt-5 mb-5 justify-content-md-center welcome-message">
                  <b-col md="9" sm="12" class="text-center" v-if="this.surveyData.overall === true">
                    <h4 class="mb-3">Hello, this is {{presenterName}},</h4>
                    <h1 class="blue-text mb-3">I am looking for feedback on my <b>overall presentation skills</b>.</h1>
                    <p>Please give me <b class="blue-text">HONEST and SPECIFIC</b> feedback about my strengths and areas to improve. (Don't worry – I can take it!)</p>
                    <p>The survey is anonymous unless, at the end, you write in your name.</p>
                    <p>Just click the link. It will take only about two – five minutes.</p>
                    <p><b>TorchMetrics — the presentation feedback and coaching system you need</b></p>
                    <h2 class="mb-5 mt-5 blue-text">Thank you!</h2>
                    <div @click="startSurvey" class="TMGeneralButton blue not-hover">GO TO SURVEY</div>
                  </b-col>
                  <b-col md="9" sm="12" class="text-center" v-else>
                    <h4 class="mb-3">Hello, this is {{presenterName}},</h4>
                    <p>I just gave a presentation called <b class="blue-text mb-3">{{ presentationName }}</b></p>
                    <p>and would greatly appreciate <b class="blue-text">HONEST and SPECIFIC</b> feedback</p>
                    <p>about my strengths and areas to improve. (Don't worry – I can take it!)</p>
                    <p>The survey is anonymous unless, at the end, you write in your name.</p>
                    <p>Just click the link. It will take only about two – five minutes.</p>
                    <p><b>TorchMetrics — the presentation feedback and coaching system you need</b></p>
                    <h2 class="mb-5 mt-5 blue-text">Thank you!</h2>
                    <div @click="startSurvey" class="TMGeneralButton blue not-hover">GO TO SURVEY</div>
                  </b-col>
                </b-row>
              </b-container>
              <b-container v-else-if="showSurvey && !showThanksSection">
                <b-row class="justify-content-md-center align-items-center">
                  <b-col md="12" sm="12">
                    <b-toast id="errorMessage" title="Error" variant="danger" auto-hide-delay="1500" toaster="b-toaster-top-right" static no-close-button>
                      <span v-html="errorMsg"></span>
                    </b-toast>
                    <form-wizard shape="tab" color="inherit" error-color="#a94442" title="" subtitle="" step-size="xs" @on-complete="finishSurvey" @on-error="handleErrorMessage" :validateOnBack="true" ref="client-survey-form-wizard">
                      <tab-content class="text-center multiple-options" v-for="(questionData, questionIndex) in surveyData.questions" :key="questionIndex" :before-change="() => validateAnswer(questionIndex, questionData)" lazy="true">
                        <b-row class="mb-4 ">
                          <b-col md="12" v-if="questionData.topic && questionData.topic !== '' && questionData.question_type === 'multiple_choice'">
                            <p class="question-topic">{{ questionData.topic }}</p>
                          </b-col>
                          <b-col md="12">
                            <h1 class="blue-text question-text">{{ questionData.question_text }}</h1>
                          </b-col>
                          <b-col md="12" v-if="questionData.question_type === 'free_form'">
                            <p>Comments and suggestions welcome</p>
                          </b-col>
                        </b-row>
                        <template v-if="questionData.question_type === 'multiple_choice'">
                          <div v-for="(answerOption , index) in questionData.answer_options" :key="index">
                            <b-row class="justify-content-md-center mb-3">
                              <b-col md="12">
                                <button class="TMGeneralButton" :class="questionData.answer === answerOption.id ? `${multipleChoicesColors[answerOption.score]} active-choice`: multipleChoicesColors[answerOption.score]" @click="addResult(questionData, answerOption.id)">{{answerOption.answer_text}}</button>
                              </b-col>
                            </b-row>
                          </div>
                        </template>
                        <b-row class="mt-4 justify-content-md-center align-items-center">
                          <b-col md="10" v-if="questionData.question_type === 'free_form'">
                            <b-form-textarea id="textarea" placeholder="Please add your comments" rows="4" max-rows="6" v-model="questionData['answer']"
                            ></b-form-textarea>
                          </b-col>
                        </b-row>
                      </tab-content>
                      <tab-content class="text-center">
                        <b-row>
                          <b-col md="12">
                            <h4 class="blue-text">Please enter your name if you want {{presenterName}} to know who you are.</h4>
                          </b-col>
                        </b-row>
                        <b-form-input v-model="clientName" placeholder="Full Name" class="mt-4"></b-form-input>
                      </tab-content>
                      <template slot="footer" slot-scope="props">
                        <div class="wizard-footer text-center">
                          <b-row align-v="center">
                            <b-col md="12" lg="12" xs="12" xl="4">
                              <TMGeneralButton @click.native="props.prevTab()" text="< Back" class="not-color-hover" data-button="back"/>
                            </b-col>
                            <b-col md="12" lg="12" xs="12" xl="4" v-if="props.isLastStep || surveyData.questions[props.activeTabIndex].question_type === 'free_form'">
                              <TMGeneralButton @click.native="props.nextTab()" :text="props.isLastStep ? 'FINISH' : 'CONTINUE'" className="blue" class="not-hover" data-button="continue"/>
                            </b-col>
                            <b-col md="12" lg="12" xs="12" xl="4">
                              <span class="slide-counter">
                                <span>{{props.activeTabIndex + 1}}</span>
                                <span class="grey-text">/{{surveyData.questions.length + 1}}</span>
                              </span>
                            </b-col>
                          </b-row>
                        </div>
                      </template>
                    </form-wizard>
                  </b-col>
                </b-row>
              </b-container>
              <b-container v-else>
                <b-row class="mt-5 mb-5 justify-content-md-center thanks-message">
                  <b-col md="9" sm="12" class="text-center">
                    <img src="/img/client-survey/thank-you-checkmark-icon-2.png" alt="Thank you checkmark icon" class="mb-3">
                    <h1 class="blue-text">Thank You!</h1>
                    <h4>I appreciate your time filling out the survey.</h4>
                    <p class="description-message">Guided by your feedback, I’ll be using TorchMetrics to improve my presentation skills. </p>
                    <p class="small-text top-line"></p>
                    <TMGeneralButton text="WWW.TORCHMETRICS.COM" route="Home" className="blue-border"/>
                    <p class="small-text"><b>TorchMetrics — An online presentation feedback and coaching system that works! </b></p>
                  </b-col>
                </b-row>
              </b-container>
            </b-row>
          </b-col>
        </b-col>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import TMGeneralButton from "@/components/common/TMGeneralButton";
import Api from "@/services/api";
import OrganizationLogo from "@/components/common/OrganizationLogo";

export default {
  name: "TakeSurvey",
  props: ["id"],
  components: {
    TMGeneralButton,
    OrganizationLogo
  },
  data: () => ({
    presenterName: '',
    presentationName: '',
    showSurvey: false,
    showThanksSection: false,
    surveyData: [],
    clientName:'',
    multipleChoicesColors:{
        100:'aqua',
        80: 'blue',
        40: 'grey',
        60: 'yellow',
        20: 'red',
        0: 'grey'
    },
    errorMsg: '',
    organizationInfo: null,
    organizationLogo: null,
  }),
  methods: {
    startSurvey() {
      this.showSurvey = true
    },
    finishSurvey(){
      const multipleChoice = this.surveyData.questions.filter(function(surveyData){
        return surveyData.question_type === "multiple_choice"
      }).map(function(answerOption){
        return {'answer_option_id': answerOption.answer}
      })

      const freeForm = this.surveyData.questions.filter(function(surveyData){
        return surveyData.question_type === "free_form" && surveyData.answer !== ''
      }).map(function(answerOption){
        return {
          "question_id": answerOption.id,
          "content": answerOption.answer
        }
      })
      const payLoad = {
        "survey_taker": {
          "full_name": this.clientName === "" ? 'Anonymous' : this.clientName,
          "presentation_id": this.id
        },
        "multiple_choice": multipleChoice,
        "free_form_responses": freeForm
      }
      Api().post('/survey_takers', payLoad)
        .then( res => {
          this.showThanksSection = true
        })
        .catch(err => {
          console.log(err)
        })
    },
    addResult(questionData, valueEl){
      questionData.answer = parseInt(valueEl)
      this.$refs["client-survey-form-wizard"].nextTab()
    },
    validateAnswer(index, questionData){
      const isBackButton = event.target.parentElement.dataset.button === 'back'
      if(isBackButton && index === 0){
        this.showSurvey = false
      }else if(isBackButton && index > 0){
        return true
      }else{
        const isFreeForm = questionData.question_type === 'free_form'
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            if(isFreeForm){
              resolve(true)
            }else{
              if(questionData.answer !== null){
                resolve(true)
              }else{
                reject('Please select an option in the current question')
              }
            }
          }, 100)
        })
      }
    },
    handleErrorMessage(errorMsg) {
      if(errorMsg){
        this.errorMsg = errorMsg
        this.$bvToast.show('errorMessage')
      }
    }
  },
  mounted() {
    Api().get(`/presentations/${this.id}`)
    .then( res => {
      this.presenterName = res.data.presenter_name;
      this.presentationName = res.data.name;
      this.organizationLogo = res.data.logo;
      this.organizationInfo = {
        logo: this.organizationLogo,
        name: res.data.organization_name
      };
      Api().get(`/surveys/${res.data.survey_id}`)
        .then( res => {
          res.data.questions.forEach(function(surveyData){
            surveyData.answer = null
          });
          this.surveyData = res.data;
        })
        .catch(err => {
          console.log(err)
        })
    })
    .catch(err => {
      console.log(err)
    });
  }
}
</script>

<style lang="less">
  @import "../../assets/components/clientSurvey/ClienteSurvey";
</style>